export default () => ({
  component: null,
  uid: null,
  props: null,
  eventName: null,
  eventData: null,
  eventWait: 0,
});
